import type {
  GetFinderItemsQueryVariables,
  ProjectStatusInput,
} from '@frameio/graphql-client/generated';
import type { ProjectSortBy } from './projects/types';
import type { SharesSortBy } from './shares/types';

export const WORKSPACE_PROJECTS_PAGE_SIZE = 15;

/**
 * @note: this variable should only be needed until a more robust solution to
 * refreshing the contents of the assets panel is built as part of the upcoming
 * uploads work
 */
export const ASSETS_QUERY_DEFAULT_ARGS: Omit<
  GetFinderItemsQueryVariables,
  'assetId'
> = {
  filters: [],
  flattenFolders: false,
  groupBys: undefined,
  sortBys: [],
  page: {
    first: 50,
  },
};

// Project Sort by Default Setup
export const DEFAULT_PROJECT_SORT_BY: ProjectSortBy = {
  field: 'default',
  order: 'asc',
};

// Shares Sort by Default Setup
export const DEFAULT_SHARES_SORT_BY: SharesSortBy = {
  field: 'UPDATED_AT',
  order: 'DESC',
};

export const DEFAULT_PROJECT_FILTERS: Array<ProjectStatusInput> = ['ACTIVE'];
